import FastForwardOutlinedIcon from '@material-ui/icons//FastForwardOutlined';
import AddIcon from '@material-ui/icons/Add';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowLeft from '@material-ui/icons/ArrowLeft';
import ArrowRight from '@material-ui/icons/ArrowRight';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import BlockIcon from '@material-ui/icons/Block';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import CancelIcon from '@material-ui/icons/Cancel';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import * as MuiChatIcon from '@material-ui/icons/Chat';
import ChatOutlinedIcon from '@material-ui/icons/ChatOutlined';
import Check from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import CollectionsIcon from '@material-ui/icons/Collections';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DeckIcon from '@material-ui/icons/Deck';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import EditIcon from '@material-ui/icons/Edit';
import CropIcon from '@material-ui/icons/Crop';
import EmailIcon from '@material-ui/icons/Email';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FaceIcon from '@material-ui/icons/Face';
import FastForward from '@material-ui/icons/FastForward';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import DownloadIcon from '@material-ui/icons/GetApp';
import GroupIcon from '@material-ui/icons/Group';
import InfoIcon from '@material-ui/icons/Info';
import InstagramIcon from '@material-ui/icons/Instagram';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import LocationOn from '@material-ui/icons/LocationOn';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import PeopleIcon from '@material-ui/icons/People';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/Phone';
import PhotoIcon from '@material-ui/icons/Photo';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import PlaceRoundedIcon from '@material-ui/icons/PlaceRounded';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import RefreshIcon from '@material-ui/icons/Refresh';
import RemoveIcon from '@material-ui/icons/Remove';
import SearchIconV2 from '@material-ui/icons/Search';
import StarIcon from '@material-ui/icons/Star';
import StorefrontIcon from '@material-ui/icons/Storefront';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewStreamIcon from '@material-ui/icons/ViewStream';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import WarningIcon from '@material-ui/icons/Warning';

import { ReactComponent as AttendeesIcon } from '../assets/eventReport/attendees.svg';
import { ReactComponent as EventReportBPLogoComplete } from '../assets/eventReport/bp-logo-complete.svg';
import EventReportBPLogo from '../assets/eventReport/BP-logo.png';
import { ReactComponent as EventReportInstagramIcon } from '../assets/eventReport/Instagram.svg';
import { ReactComponent as EventReportPresentIcon } from '../assets/eventReport/present.svg';
import { ReactComponent as ReportDotIcon } from '../assets/eventReport/report-dot.svg';
import { ReactComponent as EventReportStoryIcon } from '../assets/eventReport/Story.svg';
import { ReactComponent as EventReportTagIcon } from '../assets/eventReport/Tag.svg';
import EventReportTop10Img from '../assets/eventReport/top-10.png';
import { ReactComponent as EventReportXCompleteIcon } from '../assets/eventReport/x-complete.svg';
import { ReactComponent as UpwardArrowIcon } from '../assets/icons/arrow_down.svg';
import { ReactComponent as AutoMessageActiveIcon } from '../assets/icons/auto-message-active.svg';
import { ReactComponent as AutoMessageIcon } from '../assets/icons/auto-message.svg';
import { ReactComponent as BackIcon } from '../assets/icons/back.svg';
import { ReactComponent as BurgerIcon } from '../assets/icons/burger.svg';
import { ReactComponent as BustIcon } from '../assets/icons/bust.svg';
import { ReactComponent as CalendarIcon } from '../assets/icons/calendar.svg';
import { ReactComponent as BinIcon } from '../assets/icons/cancel.svg';
import { ReactComponent as ChatIcon } from '../assets/icons/ChatIcon.svg';
import { ReactComponent as CityIcon } from '../assets/icons/city.svg';
import { ReactComponent as CollabBlueIcon } from '../assets/icons/collab-blue.svg';
import { ReactComponent as CollabOfferIcon } from '../assets/icons/collabOffer.svg';
import { ReactComponent as ContactedIcon } from '../assets/icons/contacted-icon.svg';
import { ReactComponent as ContentFeedIcon } from '../assets/icons/content-feed.svg';
import { ReactComponent as ContentReelIcon } from '../assets/icons/content-reel.svg';
import { ReactComponent as ContentStoryIcon } from '../assets/icons/content-story.svg';
import { ReactComponent as ContentBlueIcon } from '../assets/icons/content.svg';
import { ReactComponent as ContentStatHeartIcon } from '../assets/icons/content-stat-heart.svg';
import { ReactComponent as ContentStatMessageIcon } from '../assets/icons/content-stat-message.svg';
import { ReactComponent as ContentStatShareIcon } from '../assets/icons/content-stat-share.svg';
import { ReactComponent as ContentLinkIcon } from '../assets/icons/contentLink.svg';
import { ReactComponent as BlackCrossIcon } from '../assets/icons/crossButton.svg';
import { ReactComponent as CrossBlackIcon } from '../assets/icons/crossIcon.svg';
import { ReactComponent as CrossIcon } from '../assets/icons/crossIconBlue.svg';
import { ReactComponent as ThreeStoriesIcon } from '../assets/icons/dashboard/3stories.svg';
import { ReactComponent as BeautyIcon } from '../assets/icons/dashboard/Beauty.svg';
import { ReactComponent as BotiqueIcon } from '../assets/icons/dashboard/Botique.svg';
import { ReactComponent as CollabCompleteIcon } from '../assets/icons/dashboard/CollabComplete.svg';
import { ReactComponent as DollarIcon } from '../assets/icons/dashboard/Dollar.svg';
import { ReactComponent as DrinkIcon } from '../assets/icons/dashboard/Drink.svg';
import { ReactComponent as EnvelopIcon } from '../assets/icons/dashboard/Envelop.svg';
import { ReactComponent as EventIcon } from '../assets/icons/dashboard/Event.svg';
import { ReactComponent as ExperienceIcon } from '../assets/icons/dashboard/Experience.svg';
import { ReactComponent as FeedBlueIcon } from '../assets/icons/dashboard/Feed.svg';
import { ReactComponent as FitnessIcon } from '../assets/icons/dashboard/Fitness.svg';
import { ReactComponent as FoodIcon } from '../assets/icons/dashboard/Food.svg';
import { ReactComponent as GalleryBlueIcon } from '../assets/icons/dashboard/Gallery.svg';
import { ReactComponent as ReelBlueIcon } from '../assets/icons/dashboard/Reel.svg';
import { ReactComponent as StoryBlueIcon } from '../assets/icons/dashboard/Story.svg';
import { ReactComponent as VenueWithReservationIcon } from '../assets/icons/dashboard/VenueWithReservation.svg';
import { ReactComponent as VideoBlueIcon } from '../assets/icons/dashboard/Video.svg';
import { ReactComponent as DollarV3Icon } from '../assets/icons/dollar-v2.svg';
import { ReactComponent as DollarV2Icon } from '../assets/icons/dollar.svg';
import { ReactComponent as EventOfferIcon } from '../assets/icons/event-offer.svg';
import { ReactComponent as FeedBlack } from '../assets/icons/feed-black.svg';
import { ReactComponent as Feed } from '../assets/icons/feed.svg';
import { ReactComponent as FillHeartIcon } from '../assets/icons/fill-heart.svg';
import { ReactComponent as FeedFilterIcon } from '../assets/icons/filter-feed.svg';
import { ReactComponent as ReelFilterIcon } from '../assets/icons/filter-reel.svg';
import { ReactComponent as TikTokFilterIcon } from '../assets/icons/tiktok-filter.svg';
import { ReactComponent as FilterIcon } from '../assets/icons/filters.svg';
import { ReactComponent as GalleryIcon } from '../assets/icons/galleryIcon.svg';
import { ReactComponent as StarGreenIcon } from '../assets/icons/greenStar.svg';
import { ReactComponent as HeartIcon } from '../assets/icons/heart.svg';
import { ReactComponent as HeightIcon } from '../assets/icons/height.svg';
import { ReactComponent as HipsIcon } from '../assets/icons/hips.svg';
import { ReactComponent as DropDownIcon } from '../assets/icons/Icon_Arrow-Left.svg';
import Image from '../assets/icons/image.png';
import { ReactComponent as InfoLightIcon } from '../assets/icons/info-light.svg';
import { ReactComponent as InstagramIcon2 } from '../assets/icons/instagram.svg';
import { ReactComponent as LocationIcon } from '../assets/icons/location.svg';
import { ReactComponent as MailIcon } from '../assets/icons/mail.svg';
import { ReactComponent as MessageIcon } from '../assets/icons/message.svg';
import { ReactComponent as ModelIcon } from '../assets/icons/model.svg';
import { ReactComponent as NewVenueApplicationIcon } from '../assets/icons/new-venue-application.svg';
import { ReactComponent as NewVenueIcon } from '../assets/icons/new-venue.svg';
import { ReactComponent as NoMessageIcon } from '../assets/icons/no-messages.svg';
import { ReactComponent as NoRequirement } from '../assets/icons/no-requirements.svg';
import { ReactComponent as OfferIcon } from '../assets/icons/offer.svg';
import { ReactComponent as OnlineBusinessActiveIcon } from '../assets/icons/online-business-active.svg';
import { ReactComponent as OnlineBusinessIcon } from '../assets/icons/online-business.svg';
import { ReactComponent as PaidCollabV2Icon } from '../assets/icons/paid-collab-v2.svg';
import { ReactComponent as PlusIcon } from '../assets/icons/plus.svg';
import { ReactComponent as PremiumUserIcon } from '../assets/icons/premimumUser.svg';
import { ReactComponent as PremiumHatIcon } from '../assets/icons/premiumhat.svg';
import { ReactComponent as ProIcon } from '../assets/icons/pro-icon.svg';
import { ReactComponent as ReceiverIcon } from '../assets/icons/reciever.svg';
import { ReactComponent as RecruitOfferIcon } from '../assets/icons/recuritingOffer.svg';
import { ReactComponent as ReservationBlueIcon } from '../assets/icons/recurring-blue.svg';
import { ReactComponent as RecurringOfferV2Icon } from '../assets/icons/recurring-offer-v2.svg';
import { ReactComponent as RedFlagSmallIcon } from '../assets/icons/red-flag-small.svg';
import { ReactComponent as RedFlagIcon } from '../assets/icons/red-flag.svg';
import { ReactComponent as StarRedIcon } from '../assets/icons/redStar.svg';
import { ReactComponent as ReelBlack } from '../assets/icons/reel-black.svg';
import { ReactComponent as Reel } from '../assets/icons/reel.svg';
import { ReactComponent as ReleasePaymentIcon } from '../assets/icons/release-payment.svg';
import { ReactComponent as RemoveVenueIcon } from '../assets/icons/remove-venue.svg';
import { ReactComponent as ReservationsIcon } from '../assets/icons/reservations.svg';
import { ReactComponent as RightArrowIcon } from '../assets/icons/right-arrow.svg';
import { ReactComponent as SavedIcon } from '../assets/icons/saved-icon.svg';
import { ReactComponent as ScoutingIcon } from '../assets/icons/scouting.svg';
import { ReactComponent as SearchbarIcon } from '../assets/icons/search (2).svg';
import SearchIcon from '../assets/icons/search.png';
import { ReactComponent as SearchFiltersIcon } from '../assets/icons/searchFilters.svg';
import { ReactComponent as SendIcon } from '../assets/icons/send.svg';
import { ReactComponent as SheildIcon } from '../assets/icons/sheild.svg';
import { ReactComponent as SheildBlueIcon } from '../assets/icons/shield-blue.svg';
import { ReactComponent as ShopifyIcon } from '../assets/icons/shopify.svg';
import { ReactComponent as SignedIcon } from '../assets/icons/signed-icon.svg';
import { ReactComponent as SpecialOfferIcon } from '../assets/icons/specialOffer.svg';
import { ReactComponent as RatingIcon } from '../assets/icons/starIcon.svg';
import { ReactComponent as StarterHatIcon } from '../assets/icons/starterhat.svg';
import { ReactComponent as StopPaymentIcon } from '../assets/icons/stop-payment.svg';
import { ReactComponent as StopPaymentWhiteIcon } from '../assets/icons/stop_payment_white.svg';
import { ReactComponent as StoryBlack } from '../assets/icons/story-black.svg';
import { ReactComponent as StoryFilterIcon } from '../assets/icons/story-filter.svg';
import { ReactComponent as Story3xFilterIcon } from '../assets/icons/stories3x-filter.svg';
import { ReactComponent as Story } from '../assets/icons/story.svg';
import { ReactComponent as Story3xIcon } from '../assets/icons/Story3x.svg';
import { ReactComponent as Story3xV2Icon } from '../assets/icons/story3xV2.svg';
import { ReactComponent as SupportIcon } from '../assets/icons/support.svg';
import { ReactComponent as TiktokIcon } from '../assets/icons/tiktok.svg';
import { ReactComponent as UniqueUserReservationBlue } from '../assets/icons/unique-user-reservation.svg';
import { ReactComponent as UniqueStarIcon } from '../assets/icons/uniqueStar.svg';
import { ReactComponent as UserBlueIcon } from '../assets/icons/user-blue.svg';
import { ReactComponent as UserStarBlueIcon } from '../assets/icons/user-star-blue.svg';
import { ReactComponent as UserIcon } from '../assets/icons/user.svg';
import { ReactComponent as VenueBusinessActiveIcon } from '../assets/icons/venue-business-active.svg';
import { ReactComponent as VenueBusinessIcon } from '../assets/icons/venue-business.svg';
import { ReactComponent as VenueIcon } from '../assets/icons/venue.svg';
import { ReactComponent as VerifiedIcon } from '../assets/icons/verified.svg';
import { ReactComponent as VideoIcon } from '../assets/icons/video.svg';
import { ReactComponent as ViewedIcon } from '../assets/icons/viewed-icon.svg';
import { ReactComponent as WaistIcon } from '../assets/icons/waist.svg';
import { ReactComponent as WebIcon } from '../assets/icons/web.svg';
import { ReactComponent as GiftingIcon } from '../assets/icons/gifting.svg';
import { ReactComponent as StarYellowIcon } from '../assets/icons/yellowStar.svg';
import { ReactComponent as TagIcon } from '../assets/icons/tag.svg';
import { ReactComponent as InstagramV3Icon } from '../assets/icons/instagram-v3.svg';
import { ReactComponent as DollarSignIconV4 } from '../assets/icons/dollar-sign-v4.svg';
import AgencyIcon from '../assets/images/agency.png';

export const icons = {
  CalendarTodayIcon,
  AddAPhotoIcon,
  CropIcon,
  BlackCrossIcon,
  AddIcon,
  AlternateEmailIcon,
  ArrowDownwardIcon,
  ArrowLeft,
  ArrowRight,
  ArrowUpwardIcon,
  AssignmentIcon,
  AssignmentIndIcon,
  BlockIcon,
  CancelIcon,
  CardGiftcardIcon,
  Check,
  Clear,
  CollectionsIcon,
  DashboardIcon,
  DeckIcon,
  DeleteIcon,
  DoubleArrowIcon,
  EditIcon,
  EmailIcon,
  EmojiPeopleIcon,
  EqualizerIcon,
  EventAvailableIcon,
  FaceIcon,
  FastForward,
  FastForwardOutlinedIcon,
  FavoriteIcon,
  FiberNewIcon,
  InstagramIcon,
  KeyboardBackspaceIcon,
  LocalOfferIcon,
  LocationCityIcon,
  LocationOn,
  LockIcon,
  LockOpenIcon,
  MailOutlineIcon,
  NotificationsActiveIcon,
  OndemandVideoIcon,
  PeopleIcon,
  PersonIcon,
  PhoneIcon,
  PhotoIcon,
  PhotoCameraIcon,
  RefreshIcon,
  StarIcon,
  StorefrontIcon,
  ThumbDownIcon,
  ThumbUpIcon,
  VerifiedUserIcon,
  ViewComfyIcon,
  ViewListIcon,
  ViewStreamIcon,
  Visibility,
  VisibilityOff,
  WarningIcon,
  SupportIcon,
  GalleryIcon,
  RatingIcon,
  DropDownIcon,
  StarRedIcon,
  StarGreenIcon,
  StarYellowIcon,
  CrossIcon,
  FilterIcon,
  VerifiedIcon,
  CrossBlackIcon,
  SearchIcon,
  Image,
  CloseIcon,
  BackIcon,
  ReceiverIcon,
  WebIcon,
  MailIcon,
  LocationIcon,
  InstagramIcon2,
  SheildIcon,
  CityIcon,
  UserIcon,
  ChatIcon,
  GroupIcon,
  MoreVertIcon,
  MuiChatIcon,
  SearchFiltersIcon,
  PremiumUserIcon,
  ChatOutlinedIcon,
  DoneIcon,
  DoneAllIcon,
  PlayArrowIcon,
  ContentLinkIcon,
  CollabOfferIcon,
  RecruitOfferIcon,
  SpecialOfferIcon,
  InfoIcon,
  Feed,
  FeedBlack,
  Reel,
  ReelBlack,
  Story,
  Story3xIcon,
  StoryBlack,
  NoRequirement,
  PlaceRoundedIcon,
  PlusIcon,
  EventReportTagIcon,
  EventReportInstagramIcon,
  EventReportStoryIcon,
  BurgerIcon,
  RemoveIcon,
  EventOfferIcon,
  RightArrowIcon,
  UpwardArrowIcon,
  UniqueStarIcon,
  ReservationsIcon,
  StarterHatIcon,
  PremiumHatIcon,
  BinIcon,
  SearchbarIcon,
  VideoIcon,
  HeartIcon,
  MessageIcon,
  HipsIcon,
  BustIcon,
  HeightIcon,
  WaistIcon,
  CalendarIcon,
  ReservationBlueIcon,
  UniqueUserReservationBlue,
  SheildBlueIcon,
  ShopifyIcon,
  UserBlueIcon,
  UserStarBlueIcon,
  CollabBlueIcon,
  NewVenueIcon,
  NewVenueApplicationIcon,
  RemoveVenueIcon,
  ContentBlueIcon,
  BeautyIcon,
  BotiqueIcon,
  DrinkIcon,
  EventIcon,
  ExperienceIcon,
  FitnessIcon,
  FoodIcon,
  VenueWithReservationIcon,
  EnvelopIcon,
  DollarIcon,
  CollabCompleteIcon,
  GalleryBlueIcon,
  VideoBlueIcon,
  FeedBlueIcon,
  ReelBlueIcon,
  StoryBlueIcon,
  ThreeStoriesIcon,
  ReportDotIcon,
  AttendeesIcon,
  ReleasePaymentIcon,
  StopPaymentIcon,
  StopPaymentWhiteIcon,
  ArrowForwardIosIcon,
  NoMessageIcon,
  Story3xV2Icon,
  AgencyIcon,
  VenueIcon,
  ModelIcon,
  OfferIcon,
  SendIcon,
  ExpandMoreIcon,
  SearchIconV2,
  EventReportXCompleteIcon,
  EventReportBPLogoComplete,
  EventReportPresentIcon,
  EventReportBPLogo,
  EventReportTop10Img,
  DownloadIcon,
  FillHeartIcon,
  DollarV2Icon,
  RecurringOfferV2Icon,
  PaidCollabV2Icon,
  VenueBusinessIcon,
  VenueBusinessActiveIcon,
  OnlineBusinessActiveIcon,
  OnlineBusinessIcon,
  TiktokIcon,
  RedFlagIcon,
  RedFlagSmallIcon,
  ContentFeedIcon,
  ContentStoryIcon,
  ContentReelIcon,
  ContentStatHeartIcon,
  ContentStatMessageIcon,
  ContentStatShareIcon,
  StoryFilterIcon,
  Story3xFilterIcon,
  ReelFilterIcon,
  FeedFilterIcon,
  DollarV3Icon,
  InfoLightIcon,
  AutoMessageIcon,
  AutoMessageActiveIcon,
  ProIcon,
  ScoutingIcon,
  ViewedIcon,
  SavedIcon,
  SignedIcon,
  ContactedIcon,
  GiftingIcon,
  TagIcon,
  InstagramV3Icon,
  TikTokFilterIcon,
  DollarSignIconV4,
};
